import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigProvider } from "../../../config-provider.service";
import { UtilsProvider } from "../../providers/utils-provider.service";
import { MobileSidenavService } from './mobile.sidenav.service';
import { ChatCounterService } from '../../../chat/message/chat-counter.service';
import { Subscription } from 'rxjs';
import { UsersProvider } from '../../../users/providers/users-provider';
import { CurrentUser } from '../../providers/current-user';
import { MenuItem } from "../mobile-side-menu/mobile.side-menu.component";
import { HeaderRights } from "../header-elitment/header-rights";
import { Organization } from "../../models/organization";
import { Athlete } from "../../models/athlete";
import { User } from "../../models/user";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslateModule } from "@ngx-translate/core";
import { AsyncPipe, NgIf, NgFor } from "@angular/common";
import { MatMenuModule } from "@angular/material/menu";
import { MatMiniFabButton } from "@angular/material/button";
import { LangsProvider, Lang } from "../../../common/providers/langs-provider";

@Component({
  selector: 'app-mobile-header',
  providers: [],
  styleUrls: ['./mobile.header.scss'],
  standalone: true,
  imports: [
    MatIconModule,
    MatTooltipModule,
    TranslateModule,
    NgIf,
    NgFor,
    MatMenuModule,
    MatMiniFabButton,
    AsyncPipe,

  ],
  templateUrl: './mobile.header.html'
})
export class MobileHeaderComponent implements OnInit, OnDestroy {
    @Output() public toggleSidenav = new EventEmitter<void>();

    @Input() public backMenu: MenuItem = {} as MenuItem;
    @Input() public pageTitle: string | null = null;
    @Input() public pageSubtitle: string | null = null;
    @Input() public loginNextUrl: string | null = null;
    @Input() public loginText = 'Connection';
    @Input() public hasSideMenu = false;
    @Input() public headerMarginBottom = 32;
    @Input() public logoAlwaysDisplayed = true;

    public hasScrolled = false;
    public dashboardUrl = '';
    public rights: HeaderRights = new HeaderRights(this.utils);
    public organization: Organization  = {} as Organization;
    public athleteUser: User = {} as User;
    public availableLangs: Lang[] = [];

    public totalUnseenMessages = 0;
    private subscriptions: Subscription[] = [];

    constructor(
        public conf: ConfigProvider,
        public utils: UtilsProvider,
        public currentUser: CurrentUser,
        public usersProvider: UsersProvider,
        private _router: Router,
        private _route: ActivatedRoute,
        private langsProvider: LangsProvider,
        public chatCounterService: ChatCounterService,
        public sidenavService: MobileSidenavService,
    ) {
        chatCounterService.totalUnseen$.subscribe({
            next: (count) => {
                this.totalUnseenMessages = count;
            }
        });
    }

    public ngOnInit(): void {
        this.subscriptions.push(
            this._route.data.subscribe((data: any) => {//{ organization: Organization; athlete: Athlete }
                this.organization = data.organization;
                this.athleteUser = data.athlete;

                this.dashboardUrl = data.organization.code + '/app/athletes/' + data.athlete.id;
            })
        );

        this.availableLangs = this.langsProvider.getLangs();
    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }

    public onHeaderClicked() {
        this._router.navigateByUrl(this.dashboardUrl);
    }

    public onMobileChatClicked() {
        this._router.navigate([this.organization!.code, 'app', 'athletes', this.athleteUser.id, 'chat']);
    }

    public onLangClicked(langId: number): void {
        if (this.currentUser.user!.langId !== langId) {
            const user = this.currentUser.user;
            user!.langId = langId!;
            this.usersProvider.updateUser(user?.id!, user!).subscribe(() => {
                window.location.href = this._route.snapshot.url.join('/') + '?' + this.utils.randomString(8);
            });
        }
    }
}
